import { Column, Entity, PrimaryGeneratedColumn, JoinColumn, OneToOne } from "typeorm"
import { Client } from "./Client"
import { bigint } from "../../transofrmers/BigInt"


@Entity()
export class OverageMonitor {

  @PrimaryGeneratedColumn()
  id?: number
  
  @OneToOne(() => Client, (client) => client.overage_monitor, {
    cascade: ['update']
  })
  @JoinColumn()
  client?: Client

  @Column()
  total_sims?: number

  @Column({type: 'bigint', nullable: false, transformer: bigint})
  largest_tariff?: number

  @Column({type: 'bigint', nullable: false, transformer: bigint})
  usage?: number

  @Column()
  start?: Date

  @Column()
  finish?: Date
}